import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, map } from 'rxjs';
import {DateTime} from "luxon";
import { BYPASS_LOG } from 'libs/auth/src/lib/auth.interceptor';


@Injectable({
  providedIn: 'root',
})
export class TakvimService {
  public getTasks = (): Observable<any[]> =>
    this.httpClient.get<any[]>(
      'https://js.devexpress.com/Demos/RwaService/api/Employees/AllTasks', { context: new HttpContext().set(BYPASS_LOG, true) }
    );

  constructor(private httpClient: HttpClient) {}

  public getDefaultListDS = () =>
    from([
      [
        {
          key: 'Takvimim',
          items: [
            {
              id: 0,
              text: 'Brett Johnson',
              color: '#B3E5FC',
              checkboxColor: '#29B6F6',
            },
            {
              id: 1,
              text: 'Tasks',
              color: '#C8E6C9',
              checkboxColor: '#66BB6A',
            },
            {
              id: 2,
              text: 'Reminder',
              color: '#FFCDD2',
              checkboxColor: '#EF5350',
            },
            {
              id: 3,
              text: 'Contacts',
              color: '#FFE0B2',
              checkboxColor: '#FFA726',
            },
          ],
        },
        {
          key: 'Diğer Takvimlerim',
          items: [
            {
              id: 4,
              text: 'Holidays',
              color: '#F3E5F5',
              checkboxColor: '#AB47BC',
            },
          ],
        },
      ],
    ]);

  public getAppointmentsDefaultTime = (index: any) =>
    [
      {
        weekDay: 0,
        weekIndex: 0,
        defaultTime: {
          hours: 7,
          minutes: 30,
        },
      },
      {
        weekDay: 1,
        weekIndex: 0,
        defaultTime: {
          hours: 10,
        },
      },
      {
        weekDay: 2,
        weekIndex: 0,
        defaultTime: {
          hours: 8,
          minutes: 30,
        },
      },
      {
        weekDay: 3,
        weekIndex: 0,
        defaultTime: {
          hours: 7,
        },
      },
      {
        weekDay: 0,
        weekIndex: 1,
        defaultTime: {
          hours: 9,
        },
      },
      {
        weekDay: 1,
        weekIndex: 1,
        defaultTime: {
          hours: 7,
        },
      },
      {
        weekDay: 2,
        weekIndex: 1,
        defaultTime: {
          hours: 8,
          minutes: 30,
        },
      },
      {
        weekDay: 3,
        weekIndex: 1,
        defaultTime: {
          hours: 9,
          minutes: 30,
        },
      },
      {
        weekDay: 1,
        weekIndex: 2,
        defaultTime: {
          hours: 8,
          minutes: 20,
        },
      },
      {
        weekDay: 2,
        weekIndex: 2,
        defaultTime: {
          hours: 9,
          minutes: 40,
        },
      },
      {
        weekDay: 3,
        weekIndex: 2,
        defaultTime: {
          hours: 8,
          minutes: 30,
        },
      },
    ][index];

  public getSchedulerTasks = () => {
    const promptDescription = `The HtmlEditor component is a client-side WYSIWYG text editor.
The editor allows users to format text and integrate media elements into documents.
The result can be exported to HTML or Markdown.`;

    return this.getTasks().pipe(
      map((tasks) => {
        const today = DateTime.now();
        const mondayMidnight = today.set({
          weekday: 1,
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        });
        const uniqueTasks = tasks.slice(0, 11);

        return uniqueTasks.map((task, index) => {
          const { weekDay, weekIndex, defaultTime } =
            this.getAppointmentsDefaultTime(index);
          const taskStart = mondayMidnight
            .plus({
              weeks: weekIndex,
              days: weekDay,
            })
            .plus(defaultTime);
          return {
            ...task,
            startDate: taskStart.toJSDate(),
            endDate: taskStart.plus({ hours: 3 }).toJSDate(),
            description: promptDescription,
            calendarId: weekDay,
          };
        });
      })
    );
  };
}
